/* eslint-disable @typescript-eslint/no-explicit-any */
import { TRON_CHAIN_ID } from '../../../utils/constants';
import { AbstractWalletConnector } from '../../core/AbstractWalletConnector';
import { ChainTypes } from '../../core/types';
import { addListener, isBrowser } from '../../misc';

export class TronConnector extends AbstractWalletConnector {
  readonly chainType = ChainTypes.TRON as const;

  private _provider?: any;
  public get provider() {
    return this._provider;
  }

  private _getProvider: () => Promise<any>;

  constructor(name: string, _provider: unknown) {
    super(name);
    this.chainId = TRON_CHAIN_ID;
    this._getProvider = async () => {
      const provider = typeof _provider === 'function' ? await _provider() : _provider;
      if (!provider) {
        return;
      }
      if (typeof provider === 'string') {
        return isBrowser ? window[provider] : undefined;
      }
      if (typeof provider === 'object') {
        return provider;
      }
      return;
    };
  }

  private _unSubscribeProvider: (() => void) | undefined;
  private _subscribeProvider(provider: any) {
    this._unSubscribeProvider?.();
    if (!provider.on) {
      return;
    }

    // 暂时这些都没实现，只是为了适配 bybit 插件钱包 有tron 地址和provider
    const removeAccountChange = addListener(provider, 'accountChanged', (publicKey: any) => {
      //   this._address =
    });
    const removeDisconnect = addListener(provider, 'disconnect', () => {
      this.publicKey = undefined;
      this._address = undefined;
    });

    const removeOnConnect = addListener(provider, 'connect', async () => {
      //   没这个事件
    });

    const unSubscribe = () => {
      removeAccountChange();
      removeOnConnect();
      removeDisconnect();
      this._unSubscribeProvider = undefined;
    };
    this._unSubscribeProvider = unSubscribe;
  }

  async connect(_recovery = false) {
    // 没实现
    const provider = await this.getProvider();
    if (!provider) {
      throw new Error(`${this.name} provider not found or not ready`);
    }
    const { publicKey, address } = await provider.connect();
    this.address = address;
    this.publicKey = publicKey;
    return this.address;
  }

  async disconnect() {
    // 没实现
    this.address = undefined;
    this.publicKey = undefined;
    const provider = (await this.getProvider()) as any;
    if (typeof provider?.disconnect === 'function') {
      await provider?.disconnect();
    }
    return;
  }

  async getProvider(force = false): Promise<any> {
    if (!this._provider || force) {
      const eipProvider = await this._getProvider();
      if (eipProvider) {
        this._provider = eipProvider;
        this._subscribeProvider(eipProvider);
      } else {
        this._provider = undefined;
      }
    }
    return this._provider;
  }

  async isAvailable() {
    const provider = await this.getProvider();
    return Boolean(provider);
  }
}
